<div class="export-dialog">
  <div mat-dialog-title class="dialog-title">
    <mat-icon class="title-icon" color="primary">get_app</mat-icon>
    <h2>Export {{ data.title }}</h2>
  </div>

  <div mat-dialog-content class="dialog-content">
    <form [formGroup]="exportForm" class="export-form">
      <!-- Email Addresses with Chips -->
      <div class="email-section">
        <mat-form-field appearance="outline" class="email-field">
          <mat-label>Email Addresses</mat-label>
          <mat-chip-grid #chipList aria-label="Email selection">
            @for (email of emails; track email) {
            <mat-chip-row [removable]="true" (removed)="removeEmail(email)">
              {{ email }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            }
            <input
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addEmail($event)"
              formControlName="emailInput"
            />
          </mat-chip-grid>
          <mat-hint>Enter email addresses and press Enter or comma to add multiple</mat-hint>
          @if (emailsEmpty) {
          <mat-error> At least one email address is required </mat-error>
          } @if (hasInvalidEmails) {
          <mat-error> Please enter valid email addresses </mat-error>
          }
        </mat-form-field>

        <app-alert-box
          type="info"
          message="Your export will be processed in the background and emailed when ready (usually within 2-3 minutes)"
        >
        </app-alert-box>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="dialog-actions" align="end">
    <button mat-button type="button" (click)="onCancel()" [disabled]="isProcessing">
      Cancel
    </button>

    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onExport()"
      [disabled]="emailsEmpty || hasInvalidEmails || isProcessing"
      class="export-button"
    >
      <div class="button-content">
        @if (!isProcessing) {
        <mat-icon>send</mat-icon>
        } @if (isProcessing) {
        <mat-spinner diameter="16" color="accent"></mat-spinner>
        }
        <span>{{ isProcessing ? 'Sending...' : 'Send Export' }}</span>
      </div>
    </button>
  </div>
</div>
